export default __webpack_public_path__ + "static/cert-8-img-caf48f190bd3bac4bf8d251d37f79cec.png";